exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dash {\n  margin: 0;\n  padding: 0;\n  height: 100%;\n  width: 100%; }\n\n.top-toolbar {\n  height: 6.5%; }\n\n.container {\n  height: 93.5%; }\n\n#navButtonSpacer {\n  width: 0.75em; }\n\n.search-bar {\n  -webkit-box-flex: 1;\n      -ms-flex: auto;\n          flex: auto; }\n\n.search-space {\n  width: 2em; }\n\n.search-bar * {\n  color: white !important; }\n\n.search-bar input {\n  border-bottom-color: white; }\n\na {\n  text-decoration: none; }\n\n.mat-list-item:hover {\n  background-color: lightgrey; }\n\n.mat-list-item:active {\n  background-color: slategray; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/thechairman/Documents/projects/web-app/src/app/dashboard/dashboard.component.scss
// module id = ../../../../../src/app/dashboard/dashboard.component.scss
// module chunks = main